import { UserActionTrackEventBase } from '../../types';
import { TrackedEvent } from '../../trackedEvent';

export class TrackAccountDeleted extends UserActionTrackEventBase {
    constructor() {
        super(TrackedEvent.UserAccountDeleted);
    }
}
